import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CalendarService } from '../../../services';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';

@Component({
    selector: 'sn-usc-daily-sales-panel',
    templateUrl: './usc-daily-sales-panel.component.html',
    styleUrls: ['./usc-daily-sales-panel.component.css']
})
export class UscDailySalesPanelComponent implements OnInit {
    @Input() sales_mode: string;
    @Input() scope_type: string;
    @Input() scope_value: string;
    @Input() control_id: number;
    @Input() scope_user: any;
    @Output() public viewChange = new EventEmitter();

    public p2w_goal_exceeded: number = 0;
    public p2w_quota_exceeded:number = 0;
    public days_remaining: number;
    public action_plan: any;
    public daily_goal: any;
    public isLeader: boolean = false;
    public isStoreTeam: boolean = false;
    public isSalesVsQuota: boolean = false;
    public isSalesVsGoal: boolean = false;
    public is_action_plan_loaded: boolean = false;
    public is_daily_goal_loaded: boolean = false;
    public is_daily_goal_unavailable: string = "";
    public isConsultant: boolean = false;
    public is_other_results_enabled: boolean = true;

    constructor(
        public uscStoreService: UscStoreService,
        public calendarService: CalendarService,
    ) {
        this.isLeader = this.uscStoreService.isLeader();
    }

    ngOnInit() {
        this.is_other_results_enabled = this.uscStoreService.is2022Q4Phase3Enabled();
        this.isStoreTeam = this.scope_type == "store";
        this.isConsultant = this.scope_type == "user";
        this.isSalesVsQuota = this.isLeader && this.sales_mode == 'quota';
        this.isSalesVsGoal = this.isLeader && this.sales_mode == 'goal';
        if (this.scope_type == 'user') {
            // there is a delay on the scope_type until this method gets called
            // so let's reset and proceed with loading daily goal and action plan
            this.is_daily_goal_loaded = false;
            this.is_action_plan_loaded = false;
            this.uscStoreService.getActionPlan(this.scope_user.view_ID).subscribe(result => {
                this.action_plan = result.item;
                this.is_action_plan_loaded = true;
                this.uscStoreService.getDailyGoals(this.scope_user.ur_user_ID).subscribe(result => {
                    this.daily_goal = result.items.find(p => p.cs_subject == this.uscStoreService.getTodaysGoalSubject());
                    if (this.daily_goal) {
                        this.is_daily_goal_loaded = true;
                        this.analyzeDailyGoal();
                    } else {
                        this.is_daily_goal_unavailable = 'Yes';
                    }
                })
            })
        } else {
            if (!this.isLeader) {
                this.uscStoreService.getThisMonthActionPlans().subscribe(result => {
                    this.action_plan = result;
                    this.is_action_plan_loaded = true;
                    if (this.action_plan) {
                    this.days_remaining = this.action_plan.cs_days_scheduled - this.action_plan.days_worked + 1;
                        this.uscStoreService.getTodaysGoal().subscribe(result => {
                            this.daily_goal = result;
                            this.analyzeDailyGoal();
                            this.is_daily_goal_loaded = true;
                        })    
                    } else {
                        this.is_daily_goal_loaded = true;
                    }
                })
            } else {
                // leader data are preloaded
                this.is_daily_goal_loaded = true;
                this.is_action_plan_loaded = true;
            }
        }
    }
    
    analyzeDailyGoal() {
        this.days_remaining = this.action_plan.cs_days_scheduled - this.action_plan.days_worked + 1;
        // p2w quota
        if (this.isConsultant && this.isSalesVsQuota) {
            if (parseInt(this.daily_goal.dtd_postpaid_handset_volume) >= parseInt(this.action_plan.ur_quota_postpaid_handset) / this.action_plan.cs_days_scheduled) this.p2w_quota_exceeded++;
            if (parseInt(this.daily_goal.dtd_other_volume) >= parseInt(this.action_plan.ur_quota_other_volume) / this.action_plan.cs_days_scheduled) this.p2w_quota_exceeded++;
            if (parseInt(this.daily_goal.dtd_accessories_revenue) >= parseInt(this.action_plan.ur_quota_accessories_revenue) / this.action_plan.cs_days_scheduled) this.p2w_quota_exceeded++;
            if (parseInt(this.daily_goal.dtd_other_revenue) >= parseInt(this.action_plan.ur_quota_other_revenue) / this.action_plan.cs_days_scheduled) this.p2w_quota_exceeded++;
            if (parseInt(this.daily_goal.dtd_bir) >= parseInt(this.action_plan.ur_quota_bir) / this.action_plan.cs_days_scheduled) this.p2w_quota_exceeded++;
        } else {
            // p2w goals
            if (parseInt(this.daily_goal.dtd_postpaid_handset_volume) > parseInt(this.daily_goal.cs_dg_postpaid)) this.p2w_goal_exceeded++;
            if (parseInt(this.daily_goal.dtd_other_volume) > parseInt(this.daily_goal.cs_dg_other)) this.p2w_goal_exceeded++;
            if (parseInt(this.daily_goal.dtd_accessories_revenue) > parseInt(this.daily_goal.cs_dg_accessories_revenue)) this.p2w_goal_exceeded++;
            if (parseInt(this.daily_goal.dtd_other_revenue) > parseInt(this.daily_goal.cs_dg_other_revenue)) this.p2w_goal_exceeded++;
            if (parseInt(this.daily_goal.dtd_bir) > parseInt(this.daily_goal.cs_dg_bir)) this.p2w_goal_exceeded++;
            if (parseInt(this.daily_goal.dtd_upgrades) > parseInt(this.daily_goal.cs_dg_upgrades)) this.p2w_goal_exceeded++;
            if (parseInt(this.daily_goal.dtd_high_msrp_accessories) > parseInt(this.daily_goal.cs_dg_high_acc)) this.p2w_goal_exceeded++;
            if (parseInt(this.daily_goal.dtd_device_trade_ins) > parseInt(this.daily_goal.cs_dg_device_trade_ins)) this.p2w_goal_exceeded++;
        }
    }

    getTitle(): string {
        if (this.isConsultant) {
            if (this.action_plan) return "Today - " + this.action_plan.ur_associate_name;
        } else {
            if (this.uscStoreService.isLeader()) {
                return (this.scope_type == "channel") ? "Today - National" : "Today - Team " + this.scope_value;
            } else {
                return "How today is shaping up?";
            }
        }
    }

    getDesc(): string {
        var desc = "";
        if (this.isConsultant) {
            if (this.daily_goal) desc = "Here are _NAME_ sales results for today:".replace('_NAME_', this.action_plan.ur_associate_name);
        }
        else {
            if (this.isLeader) {
                var ahead = "Congratulations, you have achieved __AHEAD__ of your Plan2Win Daily Goal(s). ".replace('__AHEAD__', this.p2w_goal_exceeded.toString());
                desc = "Here are your sales results for today:";
                desc = (this.p2w_goal_exceeded > 0) ? ahead + desc : desc;
            } else if (this.action_plan) {
                var ahead = "Congratulations, you have achieved __AHEAD__ of your Plan2Win Daily Goal(s). ".replace('__AHEAD__', this.p2w_goal_exceeded.toString());
                desc = "Here are your sales results for today:";
                desc = (this.p2w_goal_exceeded > 0) ? ahead + desc : desc;
            }
        }
        return desc;
    }

    
    getUnavailableDesc(): string {
        var desc = "";
        if (this.isConsultant) {
            if (this.is_daily_goal_unavailable == 'Yes') desc = "_NAME_ Today's Goal is not available.".replace('_NAME_', this.action_plan.ur_associate_name);
        }
        return desc;
    }

    viewTopResults() {
        var content = { view: "top_results", control_id: this.control_id };
        this.viewChange.emit(content);  
    }

    viewTopDailyResults() {
        var content = { view: "top_daily_results", control_id: this.control_id };
        this.viewChange.emit(content);  
    }

    gotoDetailedResults() {
        this.uscStoreService.setCurrentView(this.uscStoreService.view_p2w_associate_todays_detailed_results);
    }

    getDashboardClass() {
        return this.uscStoreService.getCurrentView() == this.uscStoreService.view_p2w_plan_2_win ? "sm-goal dsp" : "sm-quota dsp";
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-daily-sales-panel/usc-daily-sales-panel.component.ts